import type { ReactElement } from 'react';

import type { DrupalView } from '@commons/types/drupal';

import InsightsView from './Insights';
import PressReleaseView from './PressRelease';

/**
 * Enum of all available view types.
 *
 * Makes it easier to read and edit the ids.
 */

export enum VIEW_ID {
  Insights = 'insights',
  PressReleases = 'press_releases',
}

/**
 * Type definition for a view component.
 *
 * It has the base `DrupalView` type and infer additional properties based on the view type.
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type View<Content = any, Filters = any, SettingsFilters = any> = (
  props: DrupalView<Content, Filters, SettingsFilters>
) => ReactElement | null;

/**
 * Type definition for a nodes factory.
 *
 * It uses `string` instead of the enums as key, so that each site can have its own nodes without type issue.
 */

export type ViewsFactory = Record<string, View>;

/**
 * Factory of all available views.
 */

export const views: ViewsFactory = {
  [VIEW_ID.Insights]: InsightsView,
  [VIEW_ID.PressReleases]: PressReleaseView,
};
